export default {
    'button.cancel': 'Cancel',
    'button.save': 'Save',
    'error.internal': 'Internal server error. Please try again later.',
    'label.UID': 'SAP Number',
    'label.add': 'Add',
    'label.addDict': 'dict table',
    'label.address': 'Address',
    'label.agentEmployeeId': 'Delegate UID',
    'label.authorizer': 'Authorizer UID',
    'label.authorizerName': 'Authorizer  Name',
    'label.cancel': 'Cancel',
    'label.code': 'Code',
    'label.content': 'Content',
    'label.createTime': 'Create Time',
    'label.dataPermissions': 'Data Permissions',
    'label.delegation': 'Delegation',
    'label.delegationName': 'Delegate Name',
    'label.delete': 'Delete',
    'label.detail': 'Detail',
    'label.edit': 'Edit',
    'label.endDate': 'Submit End Date',
    'label.Date': 'Date',
    'label.endTime': 'End Time',
    'label.item': 'Item',
    'label.no': 'No',
    'label.notification.content': 'Content',
    'label.notification.content.placeholder': 'Searching content...',
    'label.notification.handle': 'Link',
    'label.notification.ignore': 'Mark read',
    'label.notification.read': 'Read',
    'label.notification.setRead': 'Read',
    'label.notification.title': 'Title',
    'label.notification.title.placeholder': 'Searching title...',
    'label.notification.unread': 'Unread',
    'label.operation': 'Action',
    'label.permission.action': 'Permission Action',
    'label.permission.code': 'Permission Code',
    'label.permission.description': 'Permission Description',
    'label.permission.name': 'Permission Name',
    'label.permission.type': 'Permission Type',
    'label.permissions': 'Permissions',
    'label.remark': 'Remark',
    'label.reset': 'Reset',
    'label.role.code': 'Role Code',
    'label.role.description': 'Role Description',
    'label.role.isGlobal': 'Global Role',
    'label.role.name': 'Role Name',
    'label.roles': 'Roles',
    'label.save': 'Save',
    'label.search': 'Search',
    'label.space': ' ',
    'label.startDate': 'Submit Start Date',
    'label.startTime': 'Submit Start Time',
    'label.status': 'Status',
    'label.submit': 'Submit',
    'label.synchronize': 'Synchonize',
    'label.total': 'Total',
    'label.type': 'Type',
    'label.user.approval-status': 'Approval Staus',
    'label.user.type': 'User Type',
    'label.username': 'Username',
    'label.yes': 'Yes',
    'menu.application-management': 'Application Management',
    'menu.audit': 'Audit',
    'menu.delegation': 'Delegation ',
    'menu.dictionary': 'Data Dictionary',
    'menu.Resource': 'Resource',
    'menu.Sourcing': 'Sourcing',
    'menu.domain': '领域',
    'menu.home': 'Home',
    'menu.homepage': 'Home Page',
    'menu.notFound': 'Not Found',
    'menu.rbac': 'RBAC',
    'menu.rbac.permission': 'Permission',
    'menu.rbac.permission.data': 'Data Permission',
    'menu.rbac.permission.home': 'Permissions',
    'menu.rbac.role': 'Role',
    'menu.rbac.user': 'User',
    'menu.rbac.user-approval': 'User Approval',
    'menu.system': 'System',
    'menu.system.dictionary': 'Data Dictionary',
    'menu.system.test': 'Demo',
    'menu.system.notification': 'Notification',
    'menu.searchTitle':'Filter',
    'menu.searchPickUpLocationTitle':'Pick-up Location Maintenance',
    'menu.searchHistoryTitle':'Nomination Check',
    'menu.menuTitle':'Query Results',
    'menu.support.maintenance':'HRBP Maintenance',
    'message.backHome': 'Back Home',
    'message.delete.confirm': 'Are you sure to delete this record?',
    'message.delete.success': 'Delete record success.',
    'message.cancel.success': 'Cancel record success.',
    'message.edit.sucess': 'Edit Successfully',
    'message.inputSearch': 'please input and click search',
    'message.noFavours': 'No Favourites',
    'message.noNotify': 'No Notify',
    'message.notfound': 'Sorry, the page you visited does not exist.',
    'message.notification.setRead': 'Are you sure to set this notification to read?',
    'message.permission.async': 'Are you sure to synchronize permissions?',
    'message.permission.delete': 'Are you sure to delete this permission?',
    'message.role.delete': 'Are you sure to delete this role?',
    'message.save.success': 'Saved.',
    'message.set.success': 'Set Successfully',
    'message.user.delete': 'Are you sure to delete this user?',
    'message.location.delete':'Are you sure to delete this location?',
    'notifier.clear': 'Clear All',
    'notifier.more': 'More',
    'rbac.role.title': 'Role',
    'rbac.user.title': 'User',
    'rule.empty': 'This field is empty.',
    'rule.endTime': 'endTime can not be empty!',
    'rule.format': 'This field format is wrong.',
    'rule.startTime': 'startTime can not be empty!',
    'rule.targetUserId': 'targetUserId can not be empty!',
    'label.table.edit':'Modify',
    'label.table.delete':'Delete',

    // 测试页
    'menu.demo':'Demo',
    'menu.demoTest':'Demo View',
    'menu.approve':'Approval & Report',
    'menu.approve.report':'Application Report',
    'menu.bestyou':'Best YOU',
    'menu.nomination':'Nomination',
    'menu.nomination.eyes':'Best in My Eyes',
    'menu.about':'About Best YOU',
    'menu.support':'Support Tool',
    'menu.support.NDelegation': 'Nomination Delegation',
    'menu.support.budget':'Budget Maintenance',
    'menu.support.demo':'Demo',
    'menu.support.cancellation':'Cancellation',
    'menu.support.pickUpLocation':'Pick-up Location Maintenance',
    'menu.support.pickUpDate':'Pick-up Dates Maintenance',
    'menu.support.congratulationTemplate':'Help Center',
    'menu.nomination.history':'Nomination History',
    'label.eyes.type':'Type',
    'label.eyes.nominee':'Nominee',
    'label.eyes.nomineeManger':'Nominee Manager',
    'label.eyes.nomineeDepartment':'Nominee Department',
    'label.eyes.criteria':'Criteria',
    'label.eyes.nominationExplanation':'Nomination Story',
    'label.eyes.nominatorName':'Nominator Name',
    'label.eyes.Behalf':'On behalf of',
    'label.eyes.NominatorDepartment':'Nominator Department',
    'label.eyes.name':'Name',
    'label.eyes.email':'Email',
    'label.eyes.staffID':'Staff ID',
    'label.eyes.managerName':'Manager Name',
    'label.eyes.managerEmail':'Manager Email',
    'label.eyes.managerDept':'Nominee Department',
    'label.close':'Close',
    'label.ok': 'OK',
    'label.userSelect':'User Selector',
    'label.name':'Name',
    'label.phone':'Phone',
    'label.email':'Email',
    'label.dept':'Department',
    'label.queryResult':'Query Result',
    'label.quicklinks':'Quick Links',
    'label.area': 'Area',
    'label.city':'City',
    'label.areaCN':'Area(CN)',
    'label.areaEN':'Area(EN)',
    'label.addressCN':'Address(CN)',
    'label.addressEN':'Address(EN)',
    'label.employeeId':'SAP Number',
    'label.shortName':'Short Name'
};
